
$(function () {
    $(".js_modal_button").on("click", function () {
        $("#" + $(this).data("modal")).addClass("active")
        $("body").addClass("scroll_lock")
    });

    $(".js_close").on("click", function () {
        $(this).parent().parent().parent().removeClass("active");
        $("body").removeClass("scroll_lock")
    });

    $(".js_modal").on("click", function (e) {
        if ($(e.target).hasClass("js_modal")) {
            $(".js_modal").removeClass("active");
            $("body").removeClass("scroll_lock")
        }
    })

    if ($(".js_acco_modal_filter")[0]) {
        $(".js_acco_modal_filter").on("click", function () {
            $(this).toggleClass("active");
        })

        $(".js_submit_filters").on("click", function () {
            var features = [];

            $(".js_acco_modal_filter.active").each(function (index) {
                features.push($(this).data('filtertype').split("=")[1]);
            });
            const urlParams = new URLSearchParams(window.location.search);

            urlParams.set("features", features.join(","))
            window.location.search = urlParams;
        })
    }
});
